import { getGlobalWindow } from './window';

export function buildApiRequestContext(): {
	originUrl: string;
	allowFastTrack: boolean;
	pageType?: string;
	mainCategory?: string;
	realSubCategory?: string;
	subCategory?: string;
} {
	const globalWindow = getGlobalWindow();

	if (
		globalWindow.digitalData &&
		globalWindow.digitalData.page &&
		globalWindow.digitalData.page.pageInfo
	) {
		return {
			originUrl: globalWindow.location.href,
			allowFastTrack: !!globalWindow.chatbotAllowFastTrack,
			pageType: globalWindow.digitalData.page.pageInfo.pageType
				? globalWindow.digitalData.page.pageInfo.pageType
				: undefined,
			mainCategory: globalWindow.digitalData.page.pageInfo.mainCategory
				? globalWindow.digitalData.page.pageInfo.mainCategory
				: undefined,
			realSubCategory: globalWindow.digitalData.page.pageInfo.realSubCategory
				? globalWindow.digitalData.page.pageInfo.realSubCategory
				: undefined,
			subCategory: globalWindow.digitalData.page.pageInfo.subCategory
				? globalWindow.digitalData.page.pageInfo.subCategory
				: undefined,
		};
	}
	return {
		originUrl: globalWindow.location.href,
		allowFastTrack: !!globalWindow.chatbotAllowFastTrack,
	};
}
